
























import Vue from 'vue';
import Component from 'vue-class-component';

import '../globals';
import { Sponsor } from '@/models/sponsor';
import SponsorCard from '@/components/sponsor-card.vue';

@Component(
    {
        components: {
            SponsorCard,
        },
    })
export default class SponsorsPage extends Vue {
    public sponsors: Sponsor[] = null;

    public async beforeCreate() {
        await this.$store.waitUntilReady();
        this.sponsors = this.$store.sponsors;
    }

}
